import CreateDisclaimerContainer from './create_disclaimer_container'

export default CreateDisclaimerContainer
